//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import uniIcons from "@/components/uni-icon/uni-icon.vue"
import subLength from '@/common/library/subLength.js'
import spotList from './components/spotList.vue'
import myContent from './components/content.vue'
// import moreContent from '@/components/more-content/index.vue'
// import uParse from '@/components/gaoyia-parse/parse.vue'
export default {
  components: { myContent, spotList, uniIcons },
  data() {
    return {
      //swiper轮播图
      indicatorDots: false, //是否显示面板指示点
      circular: true, //是否采用衔接滑动
      autoplay: true, //是否自动切换
      interval: 3000, //自动切换时间间隔
      duration: 500, //滑动动画时长
      imgList: [], //轮播图数组
      current: 1, //当前所在滑块
      currentLength: 1, //图片总数
      id: '',
      titList: [
        // 顶部tab
        {
          title: '景点推荐',
          code: '0'
        },
        {
          title: '视频短片',
          code: '1'
        },
      ],
      activeLine: '0', // tab下划线的位置
      state: '0', // 当前tab选项
      isPlayAudio: false,
      innerAudioContext: '',
      showStrategy: true,
      showSecond: true,
      // video: require('@/static/scenic/voice.png'),
      scenicspotInfo: {
        name: '',
        coverImagesUrl: '',
        scenicspotAudioUrl: '', // 景区音频地址
        videoUrl: '', // 视频地址
        virtualTourUrl: '', // 虚拟游地址
        rank: 0,
        description: '', // 一句话描述
        introduction: '', // 景区介绍
        address: '',
        openingTime: '',
        photoImagesUrls: ''
      },
      tagList: [],
      viewspotInfo: [],
      videoContext:''
    }
  },
  onLoad(event) {
    this.id = event.id
    this.queryData()
    this.innerAudioContext = uni.createInnerAudioContext();
  }, 
  onReady(res) {

        this.videoContext = uni.createVideoContext('myVideo')

    },
  computed: {
    rank() {
      return this.scenicspotInfo.rank === 1 ? '其他' : this.scenicspotInfo.rank + 'A'
    },
    videoIcon() {
      return this.isPlayAudio ? require('@/static/scenicTutorials/detailplay.png') : require('@/static/scenicTutorials/detailvoice.png')
    },
    address() {
      return subLength(this.scenicspotInfo.address, 15)
    }
  },
  methods: {
    //顶部轮播图当前图片页数
    changeImg(event) {
      this.current = event.detail.current + 1
    },
    // tab列表选择
    active(val) {
      this.state = val.code
      this.activeLine = val.code
    },
    playAudio() {
      this.innerAudioContext.onPause(() => {
        console.log('暂停');
      });
      this.innerAudioContext.onPlay(() => {
        console.log('开始播放');
      });
      this.innerAudioContext.onError((res) => {
        console.log(res.errMsg);
        console.log(res.errCode);
      });
      if (!this.innerAudioContext.paused) {
        this.innerAudioContext.pause();
      } else {
        this.innerAudioContext.play();
      }
      this.isPlayAudio = !this.isPlayAudio
    },
        videoErrorCallback(e) {
            uni.showModal({
                content: e.target.errMsg,
                showCancel: false
            })
        },
    onSuccess(state) {
      this.showStrategy = state
    },
    showPosition() {
      if (this.scenicspotInfo.latitude && this.scenicspotInfo.longitude) {











        wx.openLocation({
          latitude: parseFloat(this.scenicspotInfo.latitude), // 纬度，浮点数，范围为90 ~ -90
          longitude: parseFloat(this.scenicspotInfo.longitude), // 经度，浮点数，范围为180 ~ -180。
          name: this.scenicspotInfo.name, // 位置名
          address: this.scenicspotInfo.address, // 地址详情说明
          scale: 16, // 地图缩放级别,整形值,范围从1~28。默认为最大
          infoUrl: '' // 在查看位置界面底部显示的超链接,可点击跳转
        })

      }
    },
    async queryData() {
      uni.showLoading({
          title: '加载中',
          mask:true
      });
      let result = await this.$ajax({
        url: '/weChat/cms/scenicspot/queryById',
        method: 'post',
        data: {
          id: this.id
        }
      })
      // let { data, ...scenicspotInfo } = result.data
      this.scenicspotInfo = result.data
      this.viewspotInfo = result.data.data
      this.viewspotInfo.push.apply(this.viewspotInfo,result.data.data)
      this.scenicspotInfo.videoUrl = decodeURIComponent(this.scenicspotInfo.videoUrl)
      this.imgList = this.scenicspotInfo.photoImagesUrls.split(',')
      this.tagList = this.scenicspotInfo.secnicspotTagName ? this.scenicspotInfo.secnicspotTagName.split(',') : []
      this.currentLength = this.imgList.length || 0

      this.innerAudioContext.src = this.$getImg(this.scenicspotInfo.scenicspotAudioUrl);
      uni.hideLoading();
    }
  }
}
